<template>
<div>
<div class="table-wrapper-scroll-y my-custom-scrollbar">   
<table class="table table-sm table-bordered   mb-0" >
    <thead >
    <tr >
        <th :style="{backgroundColor : index > 3 ? 'rgb(25, 202, 25)' :'' }" v-for="(col,index) in cols" :key="index">
            {{col}}
        </th>
    </tr>
    </thead>
    <tbody>
    <tr :style="{color: setColor(item.tipo) ,fontSize:  '14px' }"  v-for="(item, index) in rows" :key="index">
    <td v-for="(col,index) in cols" :key="index">
        {{item[col]}}
    </td>
    </tr>
    </tbody>
</table>
</div>
<div class="row">
  <div class = "col">
    <h5 class="mt-4 mb-3">
      <strong>TOTALE ACQUISTATO <span class="ml-3"> {{ this.total1 }} </span> </strong>
    </h5>
  </div>
  <div class="col">
    <h5 class="mt-4 mb-3">
      <strong>TOTALE VENDUTO  <span class="ml-3"> {{ this.total2 }} </span> </strong>
    </h5>
  </div>
  <div class="col">
    <h5 class="mt-4 mb-3">
      <strong>TOTALE ESISTENZA  <span class="ml-3"> {{ this.total3 }} </span>  </strong>
    </h5>

  </div>
</div>



</div> 
</template>

<script>

import api            from '@/api'
export default {
   props: ['item'],
   components: {
  
   
  },
  data () {
    return { 

        total1 : 0,
        total2 : 0,
        total3 : 0,
        color : ['#006600','#990000','#660099'],     
        cols  : [],
        rows  : [] 
    }
  },
  computed: 
  {   
    
  },


  created()
  { 
      this.setDataPivot()
  
  },
      
  mounted()
  {},
  methods: 
  {
      setColor(type)
      {
          var color = ''
          if(type == 'ACQUISTATO')
          {
              color = this.color[0]
          }
          if(type == 'VENDUTO')
          {
              color = this.color[1]
          }  
          if(type == 'STOCK')
          {
              color = this.color[2]
          }
          return color
      },
    async setDataPivot()
    {

      
      var sp = {'sp' : 'spProductPivot'}      
      var data  = {
        'productId':this.item.productId
      }
      
      var json  = Object.assign(data, sp)
      var arr = []

      await api.post(json).then(res => {
        
          if(res.status==200)
            {

              arr = res.data.recordsets[0]

              arr.forEach(item => 
              {
              if(item.tipo == 0)
              {
                item.tipo = 'ACQUISTATO'
                this.total1 += Number(item.total)
              }
              else if(item.tipo == 1)
              {
                item.tipo = 'VENDUTO'
                this.total2 += Number(item.total)
              }
              else
              {
                item.tipo = 'STOCK'
                this.total3 += Number(item.total)
              }
          
            })

           
            var cols = []
            
            this.cols = []
            this.rows = []
            
           
            
            this.cols.push('tipo')
            this.cols.push('data')
            this.cols.push('color')
            this.cols.push('total')

            cols = arr[0]['sizes'].split('|')
            cols.forEach(item=>{
              this.cols.push(item)
            })
            this.rows = arr
         
              if(arr.length==0)
              {
               
               /*
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = 'DATI INESISTENTI.'
                this.msg.type  = 1
                */
              }

            }
            else if (res.status==500)
            {
              
              /*
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              */
            }
        
          else
          {

            
/*
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
  */                      

          }
      }).catch(err=>{
        
            /*
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1
            */
        

      }).finally(() => {
          
        });
      
      
    },
  }
  
}
</script>

<style scoped>
.detail {
    background    : darkgreen;
    font-family   : 'Roboto Condensed';
    font-size     : 20px;
}
.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}
.table-wrapper-scroll-y {
  display: block;
}

.my-custom-scrollbar {
position  : relative;
height    : 600px;
overflow  : auto;
}
.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%);  
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }
 .sizes{
  background-color: rgb(25, 202, 25) !important;
 }
</style>